export default __webpack_public_path__ + "static/alberta-01e2efc5bfc1f6aee1bc67c765ad853b.png";